import { BaseButton } from '../../UI/BaseButton';

type Layout = 'segmented' | 'list' | 'chips';

type Props = {
  options: readonly string[];
  value: string | null;
  onChange: (value: string) => void;
  layout: Layout;
};

const containerClass: Record<Layout, string> = {
  segmented: 'flex flex-wrap gap-2',
  // items-start makes the options hug their label instead of stretching to the
  // card width — full-width options read as centred and truncate awkwardly (#2746).
  list: 'flex flex-col items-start gap-2',
  chips: 'flex flex-wrap gap-2',
};

/**
 * One control for all three single-select questions (company size, referral,
 * tool). Only the layout differs; behavior is identical, which is why the review
 * collapsed three near-duplicate components into this one. Role is intentionally
 * NOT here — it's a searchable Select (RoleSelect).
 */
export default function SingleSelectQuestion({ options, value, onChange, layout }: Props) {
  return (
    <div className={containerClass[layout]} role="group">
      {options.map((option) => (
        <BaseButton
          key={option}
          type="secondary"
          size="small"
          active={value === option}
          onClick={() => onChange(option)}
          className=""
        >
          {option}
        </BaseButton>
      ))}
    </div>
  );
}
